/* eslint no-underscore-dangle: ["error", { "allow": ["_root", "_tail"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import { Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ActivateIcon from 'material-ui/svg-icons/action/done';
import DeactivateIcon from 'material-ui/svg-icons/content/clear';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

import { renderPreview } from '../../../models/NumberRange';
import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';
// import IconOpen from '../../../assets/ic-project-open.svg';
import { addFeedback } from '../../../store/modules/feedback';

import classes from './NumberRange.scss';

const mapActionCreators = {
  addFeedback,
};

const mapStateToProps = state => ({});

const renderDate = data => (
  <span>{moment(data.value).format('DD.MM.YYYY')}</span>
);

const renderFormat = data => {
  const rawFields = data.value._root.entries[1][1]._tail.array;
  const fields = [];
  const numberRangeId = data.value._root.entries[0][1];

  rawFields.forEach(field => {
    const fieldData = _.split(field, ':');
    const type = fieldData[0];
    let value = fieldData[1];
    if (type === 'interval') {
      value = {
        start: fieldData[1],
        end: fieldData[2],
        length: fieldData[3],
        current: fieldData[4],
      };
    }

    fields.push({
      type,
      value,
    });
  });
  return (
    <ul className={classes.formatList}>
      {renderPreview(fields, false, numberRangeId, true)}
    </ul>
  );
};

const renderHistoryLink = data => {
  if (data.value._root.entries[1][1] === null) {
    return <span />;
  }

  if (data.value._root.entries[4][1] === true) {
    return (
      <span>
        {data.value._root.entries[1][1]} ({data.value._root.entries[3][1]})
      </span>
    );
  }

  return (
    <Link
      to={`/${data.value._root.entries[2][1]}/${data.value._root.entries[0][1]}`}
    >
      {data.value._root.entries[1][1]} ({data.value._root.entries[3][1]})
    </Link>
  );
};

const prepareHistoryData = (dataArray, fetching) => {
  const newData = [];
  // console.log(dataArray);

  _.forEach(dataArray, value => {
    // console.log(value);
    let numberableId = null;
    let numberableName = null;
    let numberableUrlPrefix = null;
    let numberableType = null;
    let numberableDeletedAt = null;

    if (typeof value.numberable !== 'undefined' && value.numberable) {
      numberableId = value.numberable.id;
      numberableDeletedAt = value.numberable.deleted_at;

      if (typeof value.numberable.name !== 'undefined') {
        numberableName = value.numberable.name;
      } else if (typeof value.numberable.title !== 'undefined') {
        numberableName = value.numberable.title;
      }

      if (value.numberable_type === 'App\\Project') {
        numberableUrlPrefix = 'project';
        numberableType = 'Projekt';
      }
    }

    newData.push({
      id: value.id,
      number: value.number,
      link: {
        id: numberableId,
        name: numberableName,
        urlPrefix: numberableUrlPrefix,
        model: numberableType,
        deleted: numberableDeletedAt !== null,
      },
      deleted: numberableDeletedAt !== null ? 'gelöscht' : '',
    });
  });
  return newData;
};
const prepareData = (dataArray, fetching) => {
  const newData = [];
  _.forOwn(dataArray, value => {
    if (value.deleted_at === null || typeof value.deleted_at !== 'undefined') {
      const fields = [];
      value.format.forEach(field => {
        /* let fieldValue = field.value;
        if (field.type === 'interval') {
          const start = parseInt(field.value.start);
          const length = field.value.length;
          fieldValue = pad(start, length);

          fields.push({
            type: field.type,
            start: fieldValue
          });
        } else {
          fields.push({
            type: field.type,
            value: fieldValue
          });
        } */ let fieldValue =
          field.value;
        if (field.type === 'interval') {
          const start = parseInt(field.value.start, 10);
          const end = parseInt(field.value.end, 10);
          const length = field.value.length;
          const current = field.value.current;
          fieldValue = `${start}:${end}:${length}:${current}`;
        }
        fields.push(`${field.type}:${fieldValue}`);
      });
      const status = `${value.active}:${value.id}:${value.editable}:${value.deleteable}`;
      newData.push({
        id: value.id,
        title: value.name,
        createdDate: value.created_at,
        format: {
          id: value.id,
          fields,
        },
        status,
        actions: {
          id: value.id,
          active: value.active,
          editable: value.editable,
          deleteable: value.deleteable,
        },
      });
    }
  });
  return newData;
};
class NumberRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirm: null,
      historyOverlay: null,
      updating: null,
    };
  }
  componentDidMount() {
    this.props.fetchNumberRange();
  }
  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.params.numberRange !== 'undefined') {
      if (nextProps.params.numberrange.length) {
        this.props.setNumberRangeForm(nextProps.params.numberrange);
      }
    }
  }
  handleConfirmOpen = numberRangeId => {
    this.setState({
      confirm: (
        <Dialog
          actions={[
            <FlatButton
              label="Abbrechen"
              primary
              onTouchTap={e => this.handleConfirmClose()}
            />,
            <FlatButton
              label="Löschen"
              primary
              onTouchTap={e => {
                this.handleConfirmClose();
                this.props.deleteNumberRange(numberRangeId);
              }}
            />,
          ]}
          modal={false}
          open
          onRequestClose={e => this.handleConfirmClose()}
        >
          Nummernkreis wirklich löschen?
        </Dialog>
      ),
    });
  };
  handleConfirmClose = () => {
    this.setState({
      confirm: null,
    });
  };
  activateNumberRange = (event, id) => {
    const nextState = {
      ...this.props.numberRanges[id],
      activate_numberrange: id,
      fields: this.props.numberRanges[id].format,
    };
    this.props.saveNumberRange(nextState);
  };
  deactivateNumberRange = (event, id) => {
    const nextState = {
      ...this.props.numberRanges[id],
      deactivate_numberrange: id,
      fields: this.props.numberRanges[id].format,
    };
    this.props.saveNumberRange(nextState);
  };
  showHistoryOverlay = numberRangeId => {
    const props = this.props;
    const numberRange = props.numberRanges[numberRangeId];
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>
              Dieser Nummernkreis wurde bis jetzt noch nicht verwendet.
            </small>
          </p>
        </div>
      ),
    };
    this.setState({
      historyOverlay: (
        <Dialog
          title={`Verlauf von ${numberRange.name}`}
          actions={[
            <FlatButton
              label="Schließen"
              primary
              onTouchTap={e => this.hideHistoryOverlay()}
            />,
          ]}
          modal={false}
          open
          onRequestClose={e => this.hideHistoryOverlay()}
          autoScrollBodyContent
          className={classes.historyDialog}
          contentClassName={classes.historyContent}
          titleClassName={classes.historyTitle}
          actionsContainerClassName={classes.historyActions}
          bodyClassName={classes.historyBody}
        >
          <Griddle
            data={prepareHistoryData(
              numberRange.object_numbers,
              props.fetching,
            )}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            sortMethod={caseInsensitiveSort}
            components={components}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition id="number" title="#" />
              <ColumnDefinition
                id="link"
                title="Titel"
                customComponent={renderHistoryLink}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition id="deleted" title="Hinweis" />
            </RowDefinition>
          </Griddle>
        </Dialog>
      ),
    });
  };
  hideHistoryOverlay = () => {
    this.setState({
      historyOverlay: null,
    });
  };
  renderStatus = data => {
    const statusData = _.split(data.value, ':');
    const numberRangeId = statusData[1];
    const status = statusData[0] === 'true';
    if (status === true) {
      return (
        <RaisedButton
          label="Deaktivieren"
          onTouchTap={e => this.deactivateNumberRange(e, numberRangeId)}
          disabled={this.state.updating === numberRangeId}
          icon={<DeactivateIcon />}
        />
      );
    }
    return (
      <RaisedButton
        label="Aktivieren"
        primary
        onTouchTap={e => this.activateNumberRange(e, numberRangeId)}
        disabled={this.state.updating === numberRangeId}
        icon={<ActivateIcon />}
      />
    );
  };
  renderActions = data => {
    const numberRangeId = data.value._root.entries[0][1];
    const editable = data.value._root.entries[2][1] === true;
    const deleteable = data.value._root.entries[3][1] === true;

    let editMenuItemText = 'Bearbeiten';
    if (!editable) {
      editMenuItemText =
        'Nummernkreis wird verwendet und kann daher nicht bearbeitet werden';
    }

    let deleteMenuItemText = 'Löschen';
    if (!deleteable) {
      deleteMenuItemText =
        'Nummernkreis wird verwendet und kann daher nicht gelöscht werden';
    }

    return (
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreVertIcon />
          </IconButton>
        }
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        targetOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <MenuItem
          primaryText="Nummernverlauf"
          leftIcon={<HistoryIcon />}
          onTouchTap={e => this.showHistoryOverlay(numberRangeId)}
        />
        <MenuItem
          primaryText={editMenuItemText}
          leftIcon={<EditIcon />}
          disabled={!editable}
          onTouchTap={e => this.props.setNumberRangeForm(numberRangeId)}
        />
        <Divider />
        <MenuItem
          primaryText={deleteMenuItemText}
          leftIcon={<DeleteIcon />}
          disabled={!deleteable}
          onTouchTap={e => this.handleConfirmOpen(numberRangeId)}
        />
      </IconMenu>
    );
  };
  render() {
    const props = this.props;
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Nummernkreise gefunden.</small>
          </p>
        </div>
      ),
    };
    return (
      <div className="wrapper">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {Object.keys(props.numberRanges).length} Nummernkreise
          </h2>

          <Griddle
            data={prepareData(props.numberRanges, props.fetching)}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
            sortMethod={caseInsensitiveSort}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="format"
                title="Format"
                customComponent={renderFormat}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="title"
                title="Bezeichnung"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="createdDate"
                title="Hinzugefügt am"
                customComponent={renderDate}
              />
              <ColumnDefinition
                id="status"
                title="Status"
                customComponent={this.renderStatus}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="actions"
                title=" "
                sortable={false}
                locked
                width="48px"
                customComponent={this.renderActions}
              />
            </RowDefinition>
          </Griddle>
        </div>
        {this.state.confirm}
        {this.state.historyOverlay}
      </div>
    );
  }
}
NumberRange.propTypes = {
  fetchNumberRange: PropTypes.func.isRequired,
  setNumberRangeForm: PropTypes.func.isRequired,
  deleteNumberRange: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  numberRange: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  numberRanges: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  params: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  saveNumberRange: PropTypes.func.isRequired,
  addFeedback: PropTypes.func.isRequired,
};
NumberRange.defaultProps = {
  fetching: false,
  updating: null,
  numberRange: {},
  numberRanges: {},
};
export default connect(mapStateToProps, mapActionCreators)(NumberRange);



// WEBPACK FOOTER //
// ./src/routes/NumberRange/components/NumberRange.js